import { render, staticRenderFns } from "./SequenceVersion.vue?vue&type=template&id=439fabfa&scoped=true"
import script from "./SequenceVersion.vue?vue&type=script&lang=ts"
export * from "./SequenceVersion.vue?vue&type=script&lang=ts"
import style0 from "./SequenceVersion.vue?vue&type=style&index=0&id=439fabfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439fabfa",
  null
  
)

export default component.exports